export default "6e06704ad43a601f.woff2"